<template>
  <main class="page-dashboard">
    <h2 class="h1">Welcome!</h2>
    <!--Only shows if profile and bank accounts have not been properly filled-->

    <template v-if="checkLocalCurrencyWallet">
      <ul>
        <li v-if="showBanner">
          <vs-alert color="primary">
            Welcome to your TripleA Dashboard! Please complete your
            <span>profile</span> and insert <span>bank account details </span>
            <router-link to="/profile-and-bank-accounts">
              <span class="link-to-manage-accounts">here</span></router-link>
            to start withdrawing funds in selected local currencies.
          </vs-alert>
        </li>
        <li v-if="shouldShowNewsBanner">
          <!-- notification banner -->
          <vs-alert color="success" class="newsBanner">
            Refunds admin is now live! Follow
            <a
              target="_blank"
              href="https://support.triple-a.io/knowledge/how-do-i-process-refunds-to-my-customers-on-the-dashboard-1"
              rel="noopener noreferrer">our guide</a>
            to learn how you can enjoy smoother management of your refunds.
          </vs-alert>
        </li>
        <li v-if="shouldFillBankDetails">
          <p class="banner warning icon">
            Please fill in your bank details to fully enable your account (receiving payments, making payouts, etc.).
            Head over to <router-link to="/profile-and-bank-accounts">the profile page</router-link> to add the necessary informations.
          </p>
        </li>
        <!--        <li>-->
        <!--          <vs-alert class="warningBanner">-->
        <!--            Due to the upcoming Ethereum merge, payments and payouts for ETH, USDC and USDT (ERC-20) are currently unavailable. They will resume on 15 September, 08:00 (UTC).-->
        <!--          </vs-alert>-->
        <!--        </li>-->
      </ul>
    </template>

    <!--    {{timezoneNames}}-->
    <!--    <div class="custom-select" style="width:200px;">-->
    <!--      <select id="timezoneSelection" @change="changeTimeZone()">-->
    <!--        <option v-for="timezone in timezoneNames" :key="timezone" :value="timezone">-->
    <!--        {{timezone}}-->
    <!--        </option>-->
    <!--      </select>-->
    <!--    </div>-->
    <!--    {{this.$store.state.timezone}}-->

    <!--<p class="pt-2">
      You last logged in on D MMM YYYY at MM:HH.
    </p>-->

    <section class="merchant-balances">
      <h2>Balance</h2>
      <p>
        You are currently seeing the data of merchant
        <span>{{
          activeMerchantGetter ? activeMerchantGetter.merchant_name : ''
        }}</span>. To select another merchant please use the dropdown at the top of your
        screen.
      </p>
      <Balance></Balance>
    </section>
    <div>
      <br />
      <br />

      <triplea-tx-table
        title="Latest Payments received"
        :addresses="addresses"
        :transactions="transactions"
        :local-currency="localCurrencyGetter"
        :debug-selected="false"
        :debug-transactions="false"
        :max-items-per-page="4"
        :hide-pager="true"
        :viewMore="true"
        :viewMoreUrl="'/payments'"
        :exportOptions="false"
        :nested="true"
        :disableRefunds="true"></triplea-tx-table>

      <br />
      <br />

      <!-- HIDE* -->
      <!--
      <h4 class="mb-4 h3 uppercase">
        Settlement
      </h4>
      <vs-row vs-w="12" id="settlement-summary">
        <vs-col vs-w="12" class="pl-0 pr-0">
          <div class="dashboard-panel h-100">
            <vs-row vs-w="12" class="h-100 align-items-center">
              <vs-col vs-w="6" vs-sm="12">
                <span class="pr-4 pl-4 xs-hide">
                  <vs-icon icon="calendar_today" size="medium"></vs-icon>
                </span>
                Next payout :
                <strong class="no-line-wrap d-block">
                  {{ payoutNextDateGetter ? payoutNextDateGetter.toDateString() : 'no date set' }}
                </strong>
              </vs-col>
              <vs-col vs-w="6" vs-sm="12">
                <span class="pr-4 pl-4 xs-hide">
                  <vs-icon icon="account_balance" size="medium"></vs-icon>
                </span>
                The amount due to you is
                <strong class="no-line-wrap d-block">
                  {{ localCurrencyGetter }} {{ formatFiatPrice(payoutLocalAmountDueGetter) }}
                </strong>
              </vs-col>
            </vs-row>
          </div>
        </vs-col>
      </vs-row>-->

      <!--<vs-row vs-w="12">
        <vs-col vs-w="12" class="sm-mb-5 text-gray">
          <div class="pt-2 text-right">
            <sup>*</sup> Subject to 0.8% fee.
          </div>
        </vs-col>
      </vs-row>-->

      <br />
      <br />

      <h4 class="mb-4 h3 uppercase" v-if="activeAccountGetter">
        Payment activity
        <span v-if="activeAccountGetter.settlementType === 'localcurrency'">({{ localCurrencyGetter }})</span>
        <span
          v-else-if="activeAccountGetter.settlementType === 'custody' ||
            activeAccountGetter.settlementType === 'bitcoin'
            ">({{ activeAccountGetter.cryptoCurrency }})</span>
      </h4>
      <vs-row vs-w="12">
        <!-- <vs-col
          class="container_ p-0"
          v-if="accountAnalyticsData.past7days"
          vs-type="default"
          vs-justify="left"
          vs-align="center"
          vs-lg="2"
          vs-md="2"
          vs-sm="12"
          vs-xs="12"
        >
          <vs-row vs-w="12" class="space-between-content-items">
            <vs-col vs-xs="4" vs-sm="4" vs-md="12" vs-lg="12" class="p-0 pr-3">
              <div class="dashboard-panel text-center p-2">
                <p>
                  <strong style="font-size: 32px;">{{ accountAnalyticsData.today.txs }}</strong>
                </p>
                <p>Today</p>
              </div>
               <div class="dashboard-panel text-center p-2">
                <p>
                  <strong style="font-size: 32px;">{{ accountAnalyticsData.past7days.txs }}</strong>
                </p>
                <p>Past 7 days</p>
              </div>
              <div class="dashboard-panel text-center p-2">
                <p>
                  <strong style="font-size: 32px;">{{ accountAnalyticsData.past30days.txs }}</strong>
                </p>
                <p>Past 30 days</p>
              </div>
        </vs-col>-->
        <!-- <vs-col vs-xs="4" vs-sm="4" vs-md="12" vs-lg="12" class="p-0 pr-3">
              <div class="dashboard-panel text-center p-2">
                <p>
                  <strong style="font-size: 32px;">{{ accountAnalyticsData.past7days.txs }}</strong>
                </p>
                <p>Past 7 days</p>
              </div>
        </vs-col>-->
        <!-- <vs-col vs-xs="4" vs-sm="4" vs-md="12" vs-lg="12" class="p-0 pr-3">
              <div class="dashboard-panel text-center p-2">
                <p>
                  <strong style="font-size: 32px;">{{ accountAnalyticsData.past30days.txs }}</strong>
                </p>
                <p>Past 30 days</p>
              </div>
        </vs-col>-->
        <!-- </vs-row>
        </vs-col>-->
        <vs-col
          v-if="addressAnalyticsData.past7days"
          vs-type="default"
          vs-justify="left"
          vs-align="center"
          vs-lg="12"
          vs-md="12"
          vs-sm="12"
          vs-xs="12"
          class="p-0">
          <!-- Transactions Count based on Transactions API -->
          <!-- <vs-row vs-w="12" class="space-between-content-items">
            <vs-col vs-xs="12" vs-sm="12" vs-md="12" vs-lg="12" class="p-0" style="display : flex">
              <div class="dashboard-panel text-center p-2 summary-info">

                <div style="margin-bottom : 5px">
                  <p>
                    <strong>Today</strong>
                  </p>
                  <p style="font-weight: 500">Transactions : {{ accountAnalyticsData.today.txs }}</p>
                  <p
                    style="font-weight: 500"
                  >Amount : {{formatFiatPrice(accountAnalyticsData.today.amount)}}</p>
                </div>
              </div>
              <div class="dashboard-panel text-center p-2 summary-info">

                <div style="margin-bottom : 5px">
                  <p>
                    <strong>Past 7 days</strong>
                  </p>
                  <p
                    style="font-weight: 500"
                  >Transactions : {{ accountAnalyticsData.past7days.txs }}</p>
                  <p
                    style="font-weight: 500"
                  >Amount : {{formatFiatPrice(accountAnalyticsData.past7days.amount)}}</p>
                </div>
              </div>
            </vs-col>
          </vs-row> -->
          <!-- <vs-row vs-w="12" class="space-between-content-items">
            <vs-col vs-xs="12" vs-sm="12" vs-md="12" vs-lg="12" class="p-0" style="display : flex">
              <div class="dashboard-panel text-center p-2 summary-info">
                <p>
                  <strong>Past 30 days</strong>
                </p>
                <div style="margin-bottom : 5px">
                  <p style="font-weight: 500">Transactions : {{accountAnalyticsData.past30days.txs}}</p>
                  <p
                    style="font-weight: 500"
                  >Amount : {{formatFiatPrice(accountAnalyticsData.past30days.amount)}}</p>
                </div>
              </div> -->

          <!-- <div class="dashboard-panel text-center summary-info next30days">
            <div style="margin-bottom : 5px">
              <p style="margin-bottom : 10px">
                <strong>Next 30 days</strong>
              </p>
              <p
                style="font-weight: 500; margin-top:-2px"
              >Forecasted Amount : {{formatFiatPrice(accountAnalyticsData.next30days.amount)}}</p>
            </div>
          </div>
        </vs-col>
      </vs-row> -->

          <!-- Address Count based on Address API -->
          <vs-row vs-w="12" class="space-between-content-items">
            <vs-col
              vs-xs="12"
              vs-sm="12"
              vs-md="12"
              vs-lg="12"
              class="p-0"
              style="display: flex">
              <div class="dashboard-panel text-center p-2 summary-info">
                <!-- <p>
                  <strong style="font-size: 32px;">{{ accountAnalyticsData.today.txs }}</strong>

                </p>-->
                <div style="margin-bottom: 5px" v-if="activeAccountGetter">
                  <p>
                    <strong>Today</strong>
                  </p>
                  <p style="font-weight: 500">
                    Transactions : {{ addressAnalyticsData.today.txs }}
                  </p>
                  <p
                    style="font-weight: 500"
                    v-if="activeAccountGetter.settlementType === 'localcurrency'
                      ">
                    Amount :
                    {{ formatFiatPrice(addressAnalyticsData.today.amount) }}
                  </p>
                  <p
                    style="font-weight: 500"
                    v-else-if="activeAccountGetter.settlementType === 'custody' ||
                      activeAccountGetter.settlementType === 'bitcoin'
                      ">
                    Amount :
                    {{ formatCryptoPrice(addressAnalyticsData.today.amount) }}
                  </p>
                </div>
              </div>
              <div class="dashboard-panel text-center p-2 summary-info">
                <!-- <p>
                  <strong style="font-size: 32px;">{{ addressAnalyticsData.past7days.txs }}</strong>
                </p>-->
                <div style="margin-bottom: 5px" v-if="activeAccountGetter">
                  <p>
                    <strong>Past 7 days</strong>
                  </p>
                  <p style="font-weight: 500">
                    Transactions : {{ addressAnalyticsData.past7days.txs }}
                  </p>
                  <p
                    style="font-weight: 500"
                    v-if="activeAccountGetter.settlementType === 'localcurrency'
                      ">
                    Amount :
                    {{ formatFiatPrice(addressAnalyticsData.past7days.amount) }}
                  </p>
                  <p
                    style="font-weight: 500"
                    v-else-if="activeAccountGetter.settlementType === 'custody' ||
                      activeAccountGetter.settlementType === 'bitcoin'
                      ">
                    Amount :
                    {{
                      formatCryptoPrice(addressAnalyticsData.past7days.amount)
                    }}
                  </p>
                </div>
              </div>
            </vs-col>
          </vs-row>
          <vs-row vs-w="12" class="space-between-content-items">
            <vs-col
              vs-xs="12"
              vs-sm="12"
              vs-md="12"
              vs-lg="12"
              class="p-0"
              style="display: flex">
              <div class="dashboard-panel text-center p-2 summary-info">
                <p>
                  <strong>Past 30 days</strong>
                </p>
                <div style="margin-bottom: 5px" v-if="activeAccountGetter">
                  <p style="font-weight: 500">
                    Transactions : {{ addressAnalyticsData.past30days.txs }}
                  </p>
                  <p
                    style="font-weight: 500"
                    v-if="activeAccountGetter.settlementType === 'localcurrency'
                      ">
                    Amount :
                    {{
                      formatFiatPrice(addressAnalyticsData.past30days.amount)
                    }}
                  </p>
                  <p
                    style="font-weight: 500"
                    v-else-if="activeAccountGetter.settlementType === 'custody' ||
                        activeAccountGetter.settlementType === 'bitcoin'
                        ">
                    Amount :
                    {{
                      formatCryptoPrice(addressAnalyticsData.past30days.amount)
                    }}
                  </p>
                </div>
              </div>

              <div class="dashboard-panel text-center summary-info next30days">
                <div style="margin-bottom: 5px" v-if="activeAccountGetter">
                  <p style="margin-bottom: 10px">
                    <strong>Next 30 days</strong>
                  </p>
                  <p
                    style="font-weight: 500; margin-top: -2px"
                    v-if="activeAccountGetter.settlementType === 'localcurrency'
                      ">
                    Forecasted Amount :
                    {{
                      formatFiatPrice(addressAnalyticsData.next30days.amount)
                    }}
                  </p>
                  <p
                    style="font-weight: 500; margin-top: -2px"
                    v-else-if="activeAccountGetter.settlementType === 'custody' ||
                        activeAccountGetter.settlementType === 'bitcoin'
                        ">
                    Forecasted Amount :
                    {{
                      formatCryptoPrice(addressAnalyticsData.next30days.amount)
                    }}
                  </p>
                </div>
              </div>
            </vs-col>
          </vs-row>

          <!-- Chart based on Transaction API -->
          <!-- <div class="dashboard-panel p-5">
            <h4 class="h3 uppercase">Payments</h4>
            <vue-apex-charts
              id="txsPerDay"
              class="pr-5"
              ref="txsPerDay"
              type="line"
              height="260"
              :options="lineChartTxsPerDay.chartOptions"
              :series="lineChartTxsPerDay.series"
            ></vue-apex-charts>
          </div> -->

          <!-- Chart based on Address API -->
          <div class="dashboard-panel p-5">
            <h4 class="h3 uppercase">Payments</h4>
            <vue-apex-charts
              id="addrTxsPerDay"
              class="pr-5"
              ref="addrTxsPerDay"
              type="line"
              height="260"
              :options="lineChartTxsPerDay.chartOptions"
              :series="lineChartTxsPerDay.series"></vue-apex-charts>
          </div>
        </vs-col>
      </vs-row>

      <br />
      <br />
    </div>
  </main>
</template>

<script>
// import Vue from 'vue';
import VueApexCharts from 'vue-apexcharts';
import TripleaTxTable from '../../components/triplea-tx-table/TripleaTxTable';
import { mapActions, mapGetters } from 'vuex';
//MomentJS
import moment from 'moment';
import Balance from '../../components/balances/Balance.vue';

// import VueIntro from 'vue-introjs';
// Vue.use(VueIntro);

// import 'intro.js/introjs.css';

export default {
  components: {
    VueApexCharts,
    TripleaTxTable,
    Balance,
  },
  data() {
    return {
      checkLocalCurrencyWallet: false,

      debugConsole: false,
      daysToDisplay: 60,
      account: null,
      apiId: null,
      transactions: [],
      addresses: [],
      accountAnalyticsData: {},
      addressAnalyticsData: {},
      themeColors: ['#7367F0', '#28C76F', '#EA5455', '#FF9F43', '#1E1E1E'],
      lineChartTxsPerDay: {
        series: [
          {
            id: 0,
            name: 'Transactions per day',
            // data: [10, 41, 35, 51, 49, 62, 69, 91, 148]
            data: [],
          },
        ],
        chartOptions: {
          tooltip: {
            // https://apexcharts.com/docs/options/tooltip/
            enabled: true,
          },
          chart: {
            height: 250,
            zoom: {
              enabled: false,
            },
          },
          colors: this.themeColors,
          dataLabels: {
            enabled: false,
          },
          stroke: {
            show: true,
            curve: 'straight', // 'straight', 'smooth'
            lineCap: 'round',
            colors: undefined,
            width: 2,
            dashArray: 0,
          },
          // title: {
          //   text: 'Transactions per day',
          //   align: 'left'
          // },
          grid: {
            row: {
              colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
              opacity: 0.5,
            },
          },
          yaxis: {},
          xaxis: {
            type: 'category',
            // categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep','Oct','Nov','Dec'],
            categories: [],

            labels: {
              show: true,
              // rotate: -50,
              // rotateAlways: true,
              hideOverlappingLabels: true,
              showDuplicates: true,
              trim: false,
              minHeight: 50,
              maxHeight: 120,
              style: {
                colors: [],
                fontSize: '9px',
                fontFamily: 'Helvetica, Arial, sans-serif',
                cssClass: 'apexcharts-xaxis-label',
              },
              offsetX: 0,
              offsetY: 0,
              format: undefined,
              // formatter: undefined,
              // eslint-disable-next-line no-unused-vars
              formatter: function (value, timestamp, index) {
                if (!value || typeof value !== 'string') {
                  return '';
                }

                let parts = value.split(' '); // separate 'Month ##'
                let month = parts[0];
                let day = parts[1];

                if (day === '1') {
                  return month.substring(0, 3) + ' ' + day;
                } else if (
                  (parseInt(day) + 1) % 2 ||
                  (parts[0] === 'February' && parts[1] === '29') ||
                  day === '30' ||
                  day === '31'
                ) {
                  // We skip even numbers to make labels easier to read
                  return '';
                }
                return day;
              },
              datetimeFormatter: {
                year: 'yyyy',
                month: "MMM 'yy",
                day: 'dd MMM',
                hour: 'HH:mm',
              },
            },
          },
          responsive: [
            {
              breakpoint: 1200,
              options: {
                xaxis: {
                  type: 'category',
                  categories: [],
                  labels: {
                    show: true,
                    rotate: -45,
                    rotateAlways: true,
                    hideOverlappingLabels: true,
                    showDuplicates: true,
                    trim: false,
                    minHeight: 50,
                    maxHeight: 120,
                    style: {
                      colors: [],
                      fontSize: '10px',
                      fontFamily: 'Helvetica, Arial, sans-serif',
                      cssClass: 'apexcharts-xaxis-label',
                    },
                    offsetX: 0,
                    offsetY: 0,
                    format: undefined,
                    // eslint-disable-next-line no-unused-vars
                    formatter: function (value, timestamp, index) {
                      if (!value) {
                        return '';
                      }
                      let parts = value.split(' '); // separate 'Month ##'
                      let month = parts[0];
                      let day = parts[1];

                      if (day === '1') {
                        return month + ' ' + day;
                      } else if (
                        (parseInt(day) + 1) % 2 ||
                        day === '30' ||
                        day === '31'
                      ) {
                        // We skip even numbers to make labels easier to read
                        return '';
                      }

                      return day;
                    },
                    datetimeFormatter: {
                      year: 'yyyy',
                      month: "MMM 'yy",
                      day: 'dd MMM',
                      hour: 'HH:mm',
                    },
                  },
                },
              },
            },
            {
              breakpoint: 900,
              options: {
                xaxis: {
                  type: 'category',
                  categories: [],
                  labels: {
                    show: true,
                    rotate: 0,
                    rotateAlways: true,
                    hideOverlappingLabels: false,
                    showDuplicates: true,
                    trim: false,
                    minHeight: 50,
                    maxHeight: 120,
                    style: {
                      colors: [],
                      fontSize: '9px',
                      fontFamily: 'Helvetica, Arial, sans-serif',
                      cssClass: 'apexcharts-xaxis-label',
                    },
                    offsetX: 0,
                    offsetY: 0,
                    format: undefined,
                    // eslint-disable-next-line no-unused-vars
                    formatter: function (value, timestamp, index) {
                      if (!value) {
                        return '';
                      }
                      let parts = value.split(' '); // separate 'Month ##'
                      let month = parts[0];
                      let day = parts[1];

                      if (day === '1') {
                        return month + ' ' + day;
                      } else if (
                        parseInt(day) % 2 ||
                        parseInt(day) % 3 ||
                        day === '30' ||
                        day === '31'
                      ) {
                        // We skip even numbers to make labels easier to read
                        return '';
                      }

                      return day;
                    },
                    datetimeFormatter: {
                      year: 'yyyy',
                      month: "MMM 'yy",
                      day: 'dd MMM',
                      hour: 'HH:mm',
                    },
                  },
                },
              },
            },
          ],
        },
      },
      balances: [],
    };
  }, // /data
  computed: {
    ...mapGetters([
      'activeAccountGetter',
      'localCurrencyGetter',
      'transactionsGetter',
      'cleanedTransactionsGetter',
      'transactionCountsGetter',
      'payoutNextDateGetter',
      'payoutLocalAmountDueGetter',
      'addressesGetter',
      'addressesCountGetter',
      'activeMerchantGetter',
      'merchantBankAccountGetter',
      'merchantProfileDetailsGetter',
      'activeMerchantBalances',
      'localCurrencyTxnGetter',
      'activeMerchantKeyGetter',
      'localCurrencyTxnCountsGetter',
    ]),

    timezoneNames: function () {
      return moment.tz.names();
    },
    showBanner() {
      return  !this.isMerchantDetailsFilled() || !this.isMerchantBankDetailsFilled();
    },
    shouldShowNewsBanner() {
      return false;
    },
    shouldFillBankDetails() {
      return !this.isMerchantBankDetailsFilled() && !this.activeMerchantGetter.partner_id;
    },
  },
  watch: {
    activeAccountGetter(newValue, oldValue) {
      if (this.debugConsole)
        console.debug(
          'watch: activeAccountGetter: update detected',
          newValue,
          oldValue
        );

      this.pageInit();
    },
    cleanedTransactionsGetter(newValue, oldValue) {
      if (this.debugConsole)
        console.debug(
          'watch: cleanedTransactionsGetter: update detected',
          newValue,
          oldValue
        );
    },
    transactionsGetter(newValue, oldValue) {
      if (this.debugConsole)
        console.debug(
          'watch: transactionsGetter: update detected',
          newValue,
          oldValue
        );
    },
    addressesGetter(newValue, oldValue) {
      if (this.debugConsole)
        console.debug(
          'watch : addressesGetter update detected',
          newValue,
          oldValue
        );
    },
    addressesCountGetter(newValue, oldValue) {
      if (this.debugConsole)
        console.debug(
          'watch: addressesCountGetter update detected',
          newValue,
          oldValue
        );
    },
    activeMerchantGetter(newVal) {
      this.getBalances(newVal);
    },
  },
  mounted() {
    this.pageInit();
  },
  methods: {
    ...mapActions([
      'fetchAddressesAction',
      'fetchAddressesCountAction',
      'fetchMerchantBankAccounts',
      'fetchMerchantProfile',
      'fetchMerchantTransactions',
      'apiGetApprovers',
      'apiGetApproval',
    ]),
    // startTour(){
    //   this.$intro().start();
    // },
    // changeTimeZone(){
    //   var value = document.getElementById('timezoneSelection').value;
    //
    //   this.$store.commit('UPDATE_TIMEZONE', value);
    // },

    addressAnalytics() {
      this.addressAnalyticsData = {
        today: {
          name: 'Today',
          txs: 0,
          amount: 0,
        },
        past7days: {
          name: 'Past 7 days',
          txs: 0,
          amount: 0,
        },
        past30days: {
          name: 'Past 30 days',
          txs: 0,
          amount: 0,
        },
        next30days: {
          name: 'Next 30 days',
          txs: 0,
          amount: 0,
        },
      };
      let today = new Date().setUTCHours(23, 59, 59, 999);
      today = new Date(today).toISOString();
      if (this.debugConsole) console.log('Today', today);
      let yesterday =
        new Date().setUTCHours(0, 0, 0, 0) - 24 * 60 * 60 * 1000 * 1;
      yesterday = new Date(yesterday).toISOString();
      if (this.debugConsole) console.log('yesterday', yesterday);
      let sevendaysago =
        new Date().setUTCHours(0, 0, 0, 0) - 24 * 60 * 60 * 1000 * 7;
      sevendaysago = new Date(sevendaysago).toISOString();
      if (this.debugConsole) console.log('Seven Days Ago', sevendaysago);
      let thirtydaysago =
        new Date().setUTCHours(0, 0, 0, 0) - 24 * 60 * 60 * 1000 * 30;
      thirtydaysago = new Date(thirtydaysago).toISOString();
      if (this.debugConsole) console.log('thirty Days Ago', thirtydaysago);

      let addressCounts;

      //check if it is a local currency (not test account) account
      if (this.isLocalCurrencyAccount(this.activeAccountGetter)) {
        addressCounts = this.localCurrencyTxnCountsGetter;
      } else {
        addressCounts = this.addressesCountGetter;
      }

      for (const addr of addressCounts) {
        if (addr.payment_date <= today && addr.payment_date > yesterday) {
          this.addressAnalyticsData.today.txs += addr.payment_count;
          this.addressAnalyticsData.today.amount += addr.receive_amount;
        }
        if (addr.payment_date <= today && addr.payment_date > sevendaysago) {
          this.addressAnalyticsData.past7days.txs += addr.payment_count;
          this.addressAnalyticsData.past7days.amount += addr.receive_amount;
        }
        if (addr.payment_date <= today && addr.payment_date > thirtydaysago) {
          this.addressAnalyticsData.past30days.txs += addr.payment_count;
          // console.log(
          //   "this.addressAnalyticsData.past30Days",
          //   this.addressAnalyticsData.past30days.txs
          // );
          this.addressAnalyticsData.past30days.amount += addr.receive_amount;
          // console.log(
          //   "this.addressAnalyticsData.past30days amount",
          //   this.addressAnalyticsData.past30days.amount
          // );
        }
      }

      //Calculation for forecast(next 30 days)
      let totalAmountForLastTwoMonths = addressCounts.reduce(
        (accumulator, curValue) => {
          return accumulator + curValue.receive_amount;
        },
        0
      );
      let forecastedAmountForTheNext30Days = totalAmountForLastTwoMonths / 2;
      this.addressAnalyticsData.next30days.amount =
        forecastedAmountForTheNext30Days;

      // console.log("Total amount for last 2 months",totalAmountForLastTwoMonths)
      // console.log("forecast for the next 30 days",forecastedAmountForTheNext30Days)
    },

    accountAnalytics() {
      this.accountAnalyticsData = {
        today: {
          name: 'Today',
          txs: 0,
          amount: 0,
          // txsAvg: 0,
          // income: 0,
          // incomeAvg: 0,
        },
        // yesterday: {
        //   name: 'Yesterday',
        //   txs: 0,
        //   // txsAvg: 0,
        //   // income: 0,
        //   // incomeAvg: 0
        // },
        past7days: {
          name: 'Past 7 days',
          txs: 0,
          amount: 0,
          // txsAvg: 0,
          // income: 0,
          // incomeAvg: 0
        },
        past30days: {
          name: 'Past 30 days',
          txs: 0,
          amount: 0,
          // txsAvg: 0,
          // income: 0,
          // incomeAvg: 0
        },
        next30days: {
          name: 'Next 30 days', // based on last two months data Moving Average
          txs: 0,
          amount: 0,
        },
      };

      if (this.transactions.length === 0) {
        return;
      }

      // Transactions counted till today (end of day)
      let today = new Date().setUTCHours(23, 59, 59, 999);
      today = new Date(today).toISOString();
      // console.log("Today", today);
      let yesterday =
        new Date().setUTCHours(0, 0, 0, 0) - 24 * 60 * 60 * 1000 * 1;
      yesterday = new Date(yesterday).toISOString();
      // console.log("yesterday", yesterday);
      let sevendaysago =
        new Date().setUTCHours(0, 0, 0, 0) - 24 * 60 * 60 * 1000 * 7;
      sevendaysago = new Date(sevendaysago).toISOString();
      // console.log("Seven Days Ago", sevendaysago);
      let thirtydaysago =
        new Date().setUTCHours(0, 0, 0, 0) - 24 * 60 * 60 * 1000 * 30;
      thirtydaysago = new Date(thirtydaysago).toISOString();
      // console.log("thirty Days Ago", thirtydaysago);

      let txCounts = this.transactionCountsGetter;
      // console.log("this.txcounts", txCounts);

      let noOftxn = txCounts.reduce((accumulator, curVal) => {
        return accumulator + curVal.tx_count;
      }, 0);
      if (this.debugConsole) console.log('No of txn', noOftxn);

      for (const tx of txCounts) {
        if (tx.tx_date <= today && tx.tx_date > yesterday) {
          this.accountAnalyticsData.today.txs += tx.tx_count;
          this.accountAnalyticsData.today.amount += tx.receive_local_amount;
        }
        if (tx.tx_date <= today && tx.tx_date > sevendaysago) {
          this.accountAnalyticsData.past7days.txs += tx.tx_count;
          this.accountAnalyticsData.past7days.amount += tx.receive_local_amount;
        }
        if (tx.tx_date <= today && tx.tx_date > thirtydaysago) {
          this.accountAnalyticsData.past30days.txs += tx.tx_count;
          // console.log(
          //   "this.accountAnalyticsData.past30Days",
          //   this.accountAnalyticsData.past30days.txs
          // );
          this.accountAnalyticsData.past30days.amount +=
            tx.receive_local_amount;
          // console.log(
          //   "this.accountAnalyticsData.past30days amount",
          //   this.accountAnalyticsData.past30days.amount
          // );
        }
      }

      //Calculation for forecast(next 30 days)
      let totalAmountForLastTwoMonths = txCounts.reduce(
        (accumulator, curValue) => {
          return accumulator + curValue.receive_local_amount;
        },
        0
      );
      let forecastedAmountForTheNext30Days = totalAmountForLastTwoMonths / 2;
      this.accountAnalyticsData.next30days.amount =
        forecastedAmountForTheNext30Days;
    },
    pageInit() {
      this.account = this.activeAccountGetter;
      if (!this.account || !this.account.apiId) {
        console.error('pageInit(): No active wallet found.');
        this.logoutUser();
        return;
      }
      this.transactions = [...this.cleanedTransactionsGetter];
      // this.updateLineChartData();
      this.updateLineChartAddressData();
      this.accountAnalytics();
      this.addressAnalytics();

      /**
       * After displaying page contents, check for data updates.
       */

      //check if default selected merchant is using local currency wallet
      this.checkLocalCurrencyWallet =
        this.activeMerchantGetter &&
          this.activeMerchantGetter.accounts &&
          this.activeMerchantGetter.accounts.find((item) => {
            return (
              item.crypto_currency === 'BTC' &&
              item.settlement_type === 'localcurrency'
            );
          })
          ? true
          : false;

      this.apiGetMerchants().then(() => {
        if (this.debugConsole) console.debug('Get Merchant updates');
      });

      this.fetchAddressesAction().then(() => {
        if (this.debugConsole) console.debug('Fetch Addresses ');
      });
      this.fetchAddressesCountAction({
        daysToDisplay: this.daysToDisplay,
      })
        .then(() => {
          if (this.debugConsole) console.debug('Fetch Addresses Count');
        })
        .catch((err) => {
          if (this.debugConsole)
            console.log('Fetch Address Count Error', err.response);
        });

      if (this.activeMerchantKeyGetter) {
        let payload = {};
        payload.merchantKey = this.activeMerchantKeyGetter;
        this.fetchMerchantTransactions(payload).then(() => {
          if (
            this.activeAccountGetter.settlementType === 'localcurrency' &&
            !this.activeAccountGetter.apiId.includes('_t')
          ) {
            //call the local currency merchant actions
            this.addresses = this.localCurrencyTxnGetter;
            // && [...this.localCurrencyTxnGetter];
            if (this.debugConsole)
              console.log('Local currency Addresses', this.addresses);
          } else {
            if (this.debugConsole)
              console.log('Transactions are not localcurrency');
            this.addresses = [...this.addressesGetter];
          }
        });
      }

      let selectedMerchantKey =
        this.activeMerchantGetter && this.activeMerchantGetter.merchant_key;

      if (selectedMerchantKey) {
        this.fetchMerchantProfile(selectedMerchantKey).then(() => {
          if (this.debugConsole) console.debug('Fetch Merchant Profile');
        });

        this.fetchMerchantBankAccounts(selectedMerchantKey).then(() => {
          if (this.debugConsole) console.debug('Fetch merchant bank accounts');
        });

        this.apiGetCredentials(selectedMerchantKey).then(() => {
          if (this.debugConsole) console.debug('Get API credentials');
        });
      }
    },
    mostRecentTxs(txs, amount) {
      if (txs.length > amount) {
        return txs.splice(-amount);
      } else {
        return txs;
      }
    },

    updateLineChartData() {
      // We need to group transactions.

      // Transactions counted till today (end of day)
      let newestDate = new Date().setUTCHours(23, 59, 59, 999);

      // How many days do we need to display in the graph?
      let oldestDate =
        new Date().setUTCHours(0, 0, 0, 0) -
        24 * 60 * 60 * 1000 * this.daysToDisplay;

      let dateRange = this.getDates(oldestDate, newestDate);

      let transactionsPerDay = {};

      for (let i = 0; i < dateRange.length; ++i) {
        transactionsPerDay[dateRange[i]] = 0;
      }

      let txCounts = this.transactionCountsGetter;
      for (const tx of txCounts) {
        transactionsPerDay[tx.tx_date] = tx.tx_count;
      }

      // Set the time series values
      this.lineChartTxsPerDay.series[0].data =
        Object.values(transactionsPerDay);

      // Set x axis labels (for the various screen sizes)
      let xaxisLabels = this.dateToChartLabel(Object.keys(transactionsPerDay));

      this.lineChartTxsPerDay.chartOptions.xaxis.categories = xaxisLabels;
      this.lineChartTxsPerDay.chartOptions.responsive[0].options.xaxis.categories =
        xaxisLabels;
      this.lineChartTxsPerDay.chartOptions.responsive[1].options.xaxis.categories =
        xaxisLabels;

      if (this.$refs.txsPerDay)
        this.$refs.txsPerDay.updateOptions(
          this.lineChartTxsPerDay.chartOptions
        );
    },

    updateLineChartAddressData() {
      // We need to group transactions.

      // Transactions counted till today (end of day)
      let newestDate = new Date().setUTCHours(23, 59, 59, 999);

      // How many days do we need to display in the graph?
      let oldestDate =
        new Date().setUTCHours(0, 0, 0, 0) -
        24 * 60 * 60 * 1000 * this.daysToDisplay;

      let dateRange = this.getDates(oldestDate, newestDate);
      // console.log("Date Range", dateRange);

      let addressTransactionsPerDay = {};

      for (let i = 0; i < dateRange.length; ++i) {
        addressTransactionsPerDay[dateRange[i]] = 0;
      }

      // console.log("Address Txn Per Day", addressTransactionsPerDay);

      let addressCounts;

      //check if it is a local currency (not test account) account
      if (this.isLocalCurrencyAccount(this.activeAccountGetter)) {
        addressCounts = this.localCurrencyTxnCountsGetter;
      } else {
        addressCounts = this.addressesCountGetter;
      }

      for (const addr of addressCounts) {
        addressTransactionsPerDay[addr.payment_date] = addr.payment_count;
      }

      if (this.debugConsole)
        console.log('Address Txn Pe/r Day', addressTransactionsPerDay);

      // Set the time series values
      this.lineChartTxsPerDay.series[0].data = Object.values(
        addressTransactionsPerDay
      );

      // Set x axis labels (for the various screen sizes)
      let xaxisLabels = this.dateToChartLabel(
        Object.keys(addressTransactionsPerDay)
      );

      if (this.debugConsole) console.log('X Axis Label', xaxisLabels);

      this.lineChartTxsPerDay.chartOptions.xaxis.categories = xaxisLabels;
      this.lineChartTxsPerDay.chartOptions.responsive[0].options.xaxis.categories =
        xaxisLabels;
      this.lineChartTxsPerDay.chartOptions.responsive[1].options.xaxis.categories =
        xaxisLabels;

      if (this.$refs.addrTxsPerDay)
        this.$refs.addrTxsPerDay.updateOptions(
          this.lineChartTxsPerDay.chartOptions
        );
    },

    dateToChartLabel(dateArray) {
      let newDateArray = [];
      for (let i = 0; i < dateArray.length; i++) {
        let output;
        let date = new Date(dateArray[i]).getDate();
        output =
          new Date(dateArray[i]).toLocaleString('default', { month: 'long' }) +
          ' ' +
          date;
        newDateArray.push(output);
      }
      return newDateArray;
    },


    /**
     * Formats all balances for a merchant.
     * grouped by real localCurrency, test localCurrency, real custody and test custody
     * @param merchant
     * @returns {[{'currency', 'amount', 'isTest', 'id'}]}
     */
    getBalances(merchant) {
      // group accounts into one real local currency account, one test local currency account and one account for all custody
      const realLocalCurrencyAccount = {
        currency: merchant.local_currency,
        amount: 0,
        isTest: false,
        id: this.getAccountId('BTC', 'real', merchant, false),
      };
      const testLocalCurrencyAccount = {
        currency: merchant.local_currency,
        amount: 0,
        isTest: true,
        id: this.getAccountId('testBTC', 'test', merchant, false),
      };
      const res = [realLocalCurrencyAccount, testLocalCurrencyAccount];
      const custodyAccountsCurrencies =
        this.getCustodyAccountsCurrencies(merchant);

      for (let balance of merchant.balances) {
        if (
          this.isCryptoCurrency(balance.available_currency) &&
          balance.available_currency != 'testBTC'
        ) {
          // check if custody account
          if (
            custodyAccountsCurrencies.indexOf(balance.available_currency) >=
            0 &&
            balance.type === 'real'
          ) {
            res.push({
              currency: balance.available_currency,
              amount: this.formatCryptoAmount(
                balance.available_amount,
                balance.available_currency
              ),
              isTest: false,
              id: this.getAccountId(
                balance.available_currency,
                balance.type,
                merchant,
                true
              ),
            });
          } else if (balance.type === 'test') {
            res.push({
              currency: balance.available_currency,
              amount: this.formatCryptoAmount(
                balance.available_amount,
                balance.available_currency
              ),
              isTest: true,
              id: this.getAccountId(
                balance.available_currency,
                balance.type,
                merchant,
                false
              ),
            });
          }
        } else {
          if (balance.type === 'real') {
            realLocalCurrencyAccount.amount += balance.available_amount;
          } else {
            testLocalCurrencyAccount.amount += balance.available_amount;
          }
        }
      }
      realLocalCurrencyAccount.amount = this.formatFiatPrice(
        realLocalCurrencyAccount.amount
      );
      testLocalCurrencyAccount.amount = this.formatFiatPrice(
        testLocalCurrencyAccount.amount
      );
      this.balances = res;
    },
    /**
     * Gets an array of all currencies linked to a custody account
     * @param {*} merchant
     */
    getCustodyAccountsCurrencies(merchant) {
      const res = [];
      merchant.accounts.forEach((account) => {
        if (account.settlement_type === 'custody') {
          res.push(account.crypto_currency);
        }
      });
      return res;
    },
    /**
     * Find the apiId in merchant's accounts, given the currency and type of balance
     * @param {*} currency
     * @param {['real', 'test']} type
     * @param {Merchant} merchant
     * @param {boolean} isCustody
     */
    getAccountId(currency, type, merchant, isCustody) {
      for (let account of merchant.accounts) {
        let isCurrencyMatching = false;
        let isTypeMatching = false;
        let isSettlementMatching = false;
        isTypeMatching =
          (type === 'test' && this.isTestAccount(account)) ||
          (type === 'real' && !this.isTestAccount(account));
        if (account.settlement_type === 'localcurrency') {
          isCurrencyMatching = currency === account.local_currency;
          // special cases : BTC is default active account
          if (currency === 'BTC' || currency === 'testBTC') {
            isCurrencyMatching = currency === account.crypto_currency;
          }
          isSettlementMatching = isCustody ? false : true;
        } else if (account.settlement_type === 'custody') {
          isCurrencyMatching = currency === account.crypto_currency;
          isSettlementMatching = isCustody ? true : false;
        }
        if (isCurrencyMatching && isTypeMatching && isSettlementMatching) {
          return account.api_id;
        }
      }
    },
    isTestAccount(account) {
      return account.api_id && account.api_id.indexOf('_t') > 0;
    },

    isMerchantDetailsFilled() {
      return (
        this.merchantProfileDetailsGetter &&
        this.merchantProfileDetailsGetter.local_currency &&
        this.merchantProfileDetailsGetter.merchant_name &&
        this.merchantProfileDetailsGetter.id_type &&
        this.merchantProfileDetailsGetter.id_num &&
        this.merchantProfileDetailsGetter.address &&
        this.merchantProfileDetailsGetter.country &&
        this.merchantProfileDetailsGetter.contact_name &&
        this.merchantProfileDetailsGetter.contact_email &&
        this.merchantProfileDetailsGetter.contact_phone &&
        this.merchantProfileDetailsGetter.merchant_email &&
        this.merchantProfileDetailsGetter.website
      );
    },

    isMerchantBankDetailsFilled() {
      return this.merchantBankAccountGetter &&
        this.merchantBankAccountGetter[0] &&
        this.merchantBankAccountGetter[0].account_name &&
        this.merchantBankAccountGetter[0].account_num &&
        this.merchantBankAccountGetter[0].bank_name &&
        this.merchantBankAccountGetter[0].bank_address &&
        this.merchantBankAccountGetter[0].bank_country &&
        ((this.merchantBankAccountGetter[0].bank_country !== 'US' &&
          this.merchantBankAccountGetter[0].swift_bic) ||
          (this.merchantBankAccountGetter[0].bank_country === 'US' &&
            this.merchantBankAccountGetter[0].routing_num));
    },
  },
};
</script>

<style lang="scss">
.link-to-manage-accounts {
  /*color:darkgreen;*/
  text-decoration-line: underline;
}

.link-to-manage-accounts:hover {
  color: blue;
}

.page-dashboard {
  #txsPerDay {
    background: white;
  }

  &>h2 {
    margin-bottom: 12px;
  }

  &>ul {
    // List of banners
    margin-bottom: 24px;

    li {
      &:not(:last-of-type) {
        margin-bottom: 12px;
      }

      .con-vs-alert {
        height: auto !important;

        .vs-alert>span {
          font-weight: 600;
        }

        &.newsBanner .vs-alert {
          border: 1px solid #cfebd6;
          font-weight: bold;

          &>a {
            text-decoration: underline;
            color: rgb(46, 158, 81); // value from vuesax lib "success"
          }
        }

        &.warningBanner .vs-alert {
          color: #856404;
          background-color: #fff3cd;
          border-color: #ffeeba;
          &>a {
            text-decoration: underline;
            color: #856404;
          }
        }
      }
    }
  }

  section.merchant-balances {
    h2 {
      margin-bottom: 6px;
      margin-top: 12px;
      color: #505050;
      font-weight: bold;
      font-family: Montserrat, serif;
      text-transform: uppercase;
      font-size: 28px;
    }

    p {
      // max-width: 800px;
      margin-bottom: 6px;

      span {
        font-weight: 600;
      }
    }
  }

  .vs-con-tbody.vs-table--tbody {
    padding-bottom: 1.25rem;
  }

  .con-pagination-table.vs-table--pagination {
    display: none;
  }

  .border-bottom {
    border-bottom: 1px solid lightgray;
  }

  .summary-info {
    width: 100%;
    margin: 0px 0.3rem;
  }

  .next30days {
    text-align: center;
    padding: 8px 8px 6px;
  }

  @media screen and (min-width: 901px) {
    #settlement-summary {
      height: 80px;
    }

    .space-between-content-items {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-content: space-between;
      padding-right: 0rem !important;
      padding-bottom: 0.5rem !important;
    }

    .chart-panel {
      padding: 2px;
    }
  }

  @media screen and (max-width: 900px) {
    #settlement-summary {
      height: 140px;
    }

    .space-between-content-items {
      padding-right: 0 !important;
      padding-bottom: 0.8rem !important;

      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-content: space-between;

      .vs-col {
        padding-right: 0.6rem !important;
        padding-left: 0.6rem !important;
      }

      .vs-col:first-child {
        padding-left: 0 !important;
      }

      .vs-col:last-child {
        padding-right: 0 !important;
      }
    }
  }
}
</style>
